import { defineComponent as l, openBlock as o, createElementBlock as a, createElementVNode as n, createVNode as s, toDisplayString as i, createCommentVNode as c } from "vue";
import { _ as m } from "./Image.vue_vue_type_script_setup_true_lang-bc0a24ca.js";
const d = { class: "relative cursor-pointer overflow-hidden bg-gray-100" }, g = {
  ref: "container",
  class: "size-full bg-gray-100 transition-all duration-150"
}, u = {
  key: 0,
  class: "absolute bottom-1 right-1 rounded bg-black/80 px-1.5 py-1 text-sm font-bold leading-none text-white"
}, k = /* @__PURE__ */ l({
  __name: "UserGalleryGridItem",
  props: {
    imageUrl: {},
    totalImageCount: {},
    fallbackImageUrl: {}
  },
  emits: ["click"],
  setup(f, { emit: r }) {
    return (e, t) => (o(), a("div", d, [
      n("div", g, [
        s(m, {
          src: e.imageUrl,
          "img-classes": "aspect-square size-full object-cover transition-transform duration-300 lg:hover:scale-105",
          "fallback-image-url": e.fallbackImageUrl,
          onClick: t[0] || (t[0] = (p) => r("click"))
        }, null, 8, ["src", "fallback-image-url"]),
        e.totalImageCount > 1 ? (o(), a("div", u, " +" + i(e.totalImageCount - 1), 1)) : c("", !0)
      ], 512)
    ]));
  }
});
export {
  k as _
};
